import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/leave-management-system/leave-reports/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "leave-reports" entry is kept); the seo block below is a fallback.

export const leaveReports: ContentPage = {
  slug: "leave-management-system/leave-reports",
  template: "hrmsFeature",
  seo: {
    title: "Leave Reports - Generate Detailed Employee Leave Reports",
    description: "Monitor employee leave with detailed reports on leave usage, balances, and absenteeism. Export reports for deeper insights and workforce planning.",
    keywords: [
      "leave reports",
      "employee leave reports",
      "leave balance reports",
      "leave usage reports",
      "absenteeism tracking",
      "HR leave reporting",
      "leave management reports",
    ],
    ogImage: "/assets/data/seoimages/leave-reports.webp",
  },
  leaf: {
    hero: {
      caption: "Leave Reports",
      title: "Generate Comprehensive Leave Reports for Better Workforce Planning",
      description: "Gain valuable insights into employee leave patterns with detailed, customizable reports. Our Leave Reports feature helps you monitor leave usage, absenteeism, and trends to make informed decisions.",
      h1: "caption",
    },
    split: {
      title: "Advanced Leave Reporting for Comprehensive Insights",
      bullets: [
        { title: "Customizable Report Formats", description: "Create reports by leave type, department, and time period to fit your specific analysis requirements." },
        { title: "Comprehensive Leave Balances", description: "Access detailed reports on accrued, used, and available leave for each employee." },
        { title: "In-Depth Usage Reports", description: "Generate detailed reports on employee leave over time to detect patterns and manage absenteeism." },
        { title: "Absenteeism Insights", description: "Track attendance trends to identify frequent absenteeism and take appropriate actions." },
      ],
      image: "/assets/images/img/product/hrms/leavems/leave-reports_info.webp",
      imageAlt: "leave-reports_info",
    },
    cardsHeading: {
      title: "Key Features of Leave Management System",
      description: "Optimize leave management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Leave Policy & Allocation",
        href: "/hrms-software/leave-management-system/leave-policy-allocation",
        description: "Create and manage leave policies tailored to your organization’s needs. Allocate leaves based on roles, seniority, and more.",
        image: "/assets/images/img/product/hrms/leavems/leave_policy_and_allocation.webp",
        imageAlt: "leave_policy_and_allocation",
      },
      {
        title: "Leave Balance",
        href: "/hrms-software/leave-management-system/leave-balance",
        description: "Keep track of employee leave balances in real-time, ensuring transparency and accurate record-keeping.",
        image: "/assets/images/img/product/hrms/leavems/leave_balance_features.webp",
        imageAlt: "leave_balance_features",
      },
      {
        title: "Leave History",
        href: "/hrms-software/leave-management-system/leave-history",
        description: "Access detailed records of all past leaves, ensuring transparency and easy reference for both employees and HR managers.",
        image: "/assets/images/img/product/hrms/leavems/leave_history.webp",
        imageAlt: "leave_history",
      },
      {
        title: "Easy Approval",
        href: "/hrms-software/leave-management-system/leave-approval/",
        description: "Facilitate quick and easy leave request approvals or declines with a user-friendly workflow, keeping your HR processes efficient.",
        image: "/assets/images/img/product/hrms/leavems/easy_approval_decline.webp",
        imageAlt: "easy_approval",
      },
    ],
    testimonials: {
      title: "200+ Businesses across India love & trust us!",
      description: "Know why Superworks is the best HR software in India",
    },
    bookDemoTitle: "Get Started with Accurate Leave Balance Tracking",
    relatedBlogsKeyword: "what-is-hrms,leave-management-software-sme",
    metaKey: "leave-reports",
  },
  sections: [],
};
